import { API_PORTAL_URL } from "@/lib/config";
import { axiosApiInstance } from "../../helper/axios";
import {
  ITempBookingPayload,
  IFinalOrderPayload,
  IUploadPaymentPayload,
  IGetAllOrdersPayload,
  IGetCartDetailsResponse,
  IAddToCartPayload,
  IUpdateCartItemPayload,
  IUpdateOrderStatusPayload,
  ITempBookingListPayload,
  ITempBookingListResponse,
  IUpdateTempBookingFollowupPayload,
  IUpdateTempBookingFollowupResponse,
  IUpdateCartFollowupPayload,
  IUpdateCartFollowupResponse,
  IUpdateOrderDeliveryChargesPayload,
  IUpdateOrderDeliveryChargesResponse,
  IInsertCancelledOrderItemsPayload,
  IInsertCancelledOrderItemsResponse,
  IDeleteCancelledOrderItemPayload,
  IDeleteCancelledOrderItemResponse,
} from "./bookingModel";

export const insertTempBooking = async (payload: ITempBookingPayload) => {
  const response = await axiosApiInstance.post(
    `${API_PORTAL_URL}/Booking/InsertTempBooking`,
    payload,
  );
  return response.data;
};

export const createFinalOrder = async (payload: IFinalOrderPayload) => {
  const response = await axiosApiInstance.post(
    `${API_PORTAL_URL}/Booking/CreateFinalOrder`,
    payload,
  );
  return response.data;
};

export const uploadPaymentImages = async (payload: IUploadPaymentPayload) => {
  const formData = new FormData();
  formData.append("OrderID", payload.OrderID.toString());
  formData.append("CreatedBy", payload.CreatedBy.toString());
  formData.append("PaymentImages", payload.PaymentImages);

  const response = await axiosApiInstance.post(
    `${API_PORTAL_URL}/Booking/UploadPaymentImages`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};

export const getCustomerOrders = async (payload: { CustomerID: number }) => {
  const response = await axiosApiInstance.post(
    `${API_PORTAL_URL}/Booking/GetCustomerOrders`,
    payload,
  );
  return response.data;
};

export const getOrderDetails = async (payload: { OrderID: number }) => {
  const response = await axiosApiInstance.post(
    `${API_PORTAL_URL}/Booking/GetOrderDetails`,
    payload,
  );
  return response.data;
};

export const getAllOrders = async (payload: IGetAllOrdersPayload) => {
  const response = await axiosApiInstance.post(
    `${API_PORTAL_URL}/Booking/GetAllOrders`,
    payload,
  );
  return response.data;
};

export const getCartDetails = async (CustomerID: number) => {
  const response = await axiosApiInstance.post(
    `${API_PORTAL_URL}/Booking/GetCartDetails`,
    { CustomerID }
  );
  return response.data as IGetCartDetailsResponse;
};

export const addToCart = async (payload: IAddToCartPayload) => {
  const response = await axiosApiInstance.post(
    `${API_PORTAL_URL}/Booking/AddToCart`,
    payload
  );
  return response.data;
};

export const updateCartItem = async (payload: IUpdateCartItemPayload) => {
  const response = await axiosApiInstance.post(
    `${API_PORTAL_URL}/Booking/UpdateCartItem`,
    payload
  );
  return response.data;
};

export const updateOrderStatus = async (payload: IUpdateOrderStatusPayload) => {
  const response = await axiosApiInstance.post(
    `${API_PORTAL_URL}/Booking/UpdateOrderStatus`,
    payload
  );
  return response.data;
};

export const getOrderDetailsForPrint = async (payload: { OrderGUID: string }) => {
  const response = await axiosApiInstance.post(
    `${API_PORTAL_URL}/Booking/GetOrderDetailsForPrint`,
    payload
  );
  return response.data;
};

export const createPaymentOrder = async (payload: {
  Amount: number;
  Currency?: string;
}) => {
  const response = await axiosApiInstance.post(
    `${API_PORTAL_URL}/RazorpayGateway/CreateOrder`,
    payload
  );
  return response.data;
};

export const verifyPayment = async (payload: {
  RazorpayOrderId: string;
  RazorpayPaymentId: string;
  RazorpaySignature: string;
  booking_no: string;
}) => {
  const response = await axiosApiInstance.post(
    `${API_PORTAL_URL}/RazorpayGateway/verify`,
    payload
  );
  return response.data;
};

export const getCustomerConfirmOrders = async (payload: {
  CustomerID: number;
  Limit?: number;
  Skip?: number;
}) => {
  const response = await axiosApiInstance.post(
    `${API_PORTAL_URL}/Booking/GetCustomerConfirmOrders`,
    {
      CustomerID: payload.CustomerID,
      Limit: payload.Limit ?? 1000,
      Skip: payload.Skip ?? 0,
    }
  );
  return response.data;
};

export const getTempBookingList = async (
  payload?: ITempBookingListPayload
) => {
  const response = await axiosApiInstance.post(
    `${API_PORTAL_URL}/Booking/TempBookingList`,
    {
      FullName: payload?.FullName ?? "",
      MobileNo: payload?.MobileNo ?? "",
    }
  );
  return response.data as ITempBookingListResponse;
};

export const updateTempBookingFollowup = async (
  payload: IUpdateTempBookingFollowupPayload
) => {
  const response = await axiosApiInstance.post(
    `${API_PORTAL_URL}/Booking/UpdateTempBookingFollowup`,
    payload
  );
  return response.data as IUpdateTempBookingFollowupResponse;
};

export const updateCartFollowup = async (
  payload: IUpdateCartFollowupPayload
) => {
  const response = await axiosApiInstance.post(
    `${API_PORTAL_URL}/Booking/UpdateCartFollowup`,
    payload
  );
  return response.data as IUpdateCartFollowupResponse;
};

export const updateOrderDeliveryCharges = async (
  payload: IUpdateOrderDeliveryChargesPayload
) => {
  const response = await axiosApiInstance.post(
    `${API_PORTAL_URL}/Booking/UpdateOrderDeliveryCharges`,
    payload
  );
  return response.data as IUpdateOrderDeliveryChargesResponse;
};

export const insertCancelledOrderItems = async (
  payload: IInsertCancelledOrderItemsPayload
) => {
  const response = await axiosApiInstance.post(
    `${API_PORTAL_URL}/Booking/InsertCancelledOrderItems`,
    payload
  );
  return response.data as IInsertCancelledOrderItemsResponse;
};

export const deleteCancelledOrderItem = async (
  payload: IDeleteCancelledOrderItemPayload
) => {
  const response = await axiosApiInstance.post(
    `${API_PORTAL_URL}/Booking/DeleteCancelledOrderItem`,
    payload
  );
  return response.data as IDeleteCancelledOrderItemResponse;
};




